/* Classy Privée smart search redirector
 * Converts clear customer queries like "pantalón 10days" into Shopify structured search.
 * Safe fallback: if no known brand + category pattern is detected, native Shopify search runs unchanged.
 */
(function () {
  'use strict';

  var BRAND_RULES = [
    { canonical: '10Days', patterns: [/\b10\s*days\b/i, /\b10days\b/i] },
    { canonical: 'Suncoo', patterns: [/\bsuncoo\b/i] },
    { canonical: 'MesDemoiselles', patterns: [/\bmes\s*demoiselles\b/i, /\bmesdemoiselles\b/i, /\bmes\s+demoiselle\b/i, /\bmesdemoiselle\b/i] },
    { canonical: 'Sofie Schnoor', patterns: [/\bsofie\s*schnoor\b/i] },
    { canonical: 'Coster Copenhagen', patterns: [/\bcoster\b/i, /\bcostes\b/i, /\bcoster\s*copenhagen\b/i] },
    { canonical: 'Commelle', patterns: [/\bcommelle\b/i] },
    { canonical: 'Drykorn', patterns: [/\bdrykorn\b/i] },
    { canonical: 'Five', patterns: [/\bfive\b/i] },
    { canonical: 'Goldgarn', patterns: [/\bgoldgarn\b/i] },
    { canonical: 'Maison Hotel', patterns: [/\bmaison\s*hotel\b/i] },
    { canonical: 'Part Two', patterns: [/\bpart\s*two\b/i] },
    { canonical: 'Sita Murt', patterns: [/\bsita\s*murt\b/i] },
    { canonical: 'Stella Forest', patterns: [/\bstella\s*forest\b/i] },
    { canonical: 'The Boost', patterns: [/\bthe\s*boost\b/i] },
    { canonical: 'Tiny Cottons', patterns: [/\btiny\s*cottons\b/i] }
  ];

  var CATEGORY_RULES = [
    { token: 'title:Pantalones', patterns: [/\bpantal[oó]n(?:es)?\b/i, /\bpants\b/i] },
    { token: 'title:Camisa', patterns: [/\bcamisa(?:s)?\b/i] },
    { token: 'title:Blusa', patterns: [/\bblusa(?:s)?\b/i] },
    { token: 'title:Falda', patterns: [/\bfalda(?:s)?\b/i] },
    { token: 'title:Vestido', patterns: [/\bvestido(?:s)?\b/i] },
    { token: 'title:Jersey', patterns: [/\bjersey(?:s)?\b/i, /\bjerseys\b/i] },
    { token: 'title:Chaqueta', patterns: [/\bchaqueta(?:s)?\b/i] },
    { token: 'title:Abrigo', patterns: [/\babrigo(?:s)?\b/i] },
    { token: 'title:Short', patterns: [/\bshort(?:s)?\b/i] }
  ];

  function normalizeText(value) {
    return String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function findRule(query, rules) {
    var normalized = normalizeText(query);
    for (var i = 0; i < rules.length; i += 1) {
      var rule = rules[i];
      for (var j = 0; j < rule.patterns.length; j += 1) {
        if (rule.patterns[j].test(query) || rule.patterns[j].test(normalized)) return rule;
      }
    }
    return null;
  }

  function buildSmartQuery(rawQuery) {
    var query = String(rawQuery || '').trim();
    if (!query || /\b(?:vendor|tag|product_type):/i.test(query)) return query;

    var brand = findRule(query, BRAND_RULES);
    var category = findRule(query, CATEGORY_RULES);
    if (!brand || !category) return query;

    return 'vendor:' + brand.canonical + ' ' + category.token;
  }

  function ensureHiddenInput(form, name, value) {
    var input = form.querySelector('input[name="' + name + '"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      form.appendChild(input);
    }
    input.value = value;
  }

  function storageKey(smartQuery) {
    return 'classySmartSearchOriginal:' + smartQuery;
  }

  function rememberOriginalQuery(original, smart) {
    try {
      window.sessionStorage.setItem(storageKey(smart), original);
    } catch (_) {}
  }

  function restoreOriginalQueryLabel() {
    var params = new URLSearchParams(window.location.search || '');
    var smart = params.get('q');
    if (!smart || !/\b(?:vendor|tag|product_type):/i.test(smart)) return;

    var original = '';
    try {
      original = window.sessionStorage.getItem(storageKey(smart)) || '';
    } catch (_) {}
    if (!original) return;

    var searchInput = document.querySelector('input[name="q"], textarea[name="q"]');
    if (searchInput) searchInput.value = original;

    var quotedSmart = '"' + smart + '"';
    var quotedOriginal = '"' + original + '"';
    document.title = document.title.replace(smart, original).replace(quotedSmart, quotedOriginal);

    Array.prototype.forEach.call(document.querySelectorAll('h1, .h2'), function (node) {
      if (node && node.textContent && node.textContent.indexOf(smart) !== -1) {
        node.textContent = node.textContent.replace(smart, original);
      }
    });
  }

  function handleSubmit(event) {
    var form = event.target;
    if (!form || !form.matches || !form.matches('form[action*="/search"]')) return;

    var input = form.querySelector('input[name="q"], textarea[name="q"]');
    if (!input) return;

    var original = String(input.value || '').trim();
    var smart = buildSmartQuery(original);
    if (!smart || smart === original) return;

    rememberOriginalQuery(original, smart);
    input.value = smart;
    ensureHiddenInput(form, 'type', 'product');
  }

  document.addEventListener('submit', handleSubmit, true);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', restoreOriginalQueryLabel);
  } else {
    restoreOriginalQueryLabel();
  }
})();
